{
	"submitTitle": "Επιλέξτε υλικό",
	"summary": {
		"title": "Περίληψη",
		"declarationTypeTitle": "Τύπος δήλωσης",
		"projectReferenceTitle": "Αναφορά έργου"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Επιλέξτε τον τύπο δήλωσης",
			"customerProject": {
				"title": "Έργο πελάτη",
				"description": "Το υλικό χρησιμοποιήθηκε για εξωτερικό έργο. Τώρα πρέπει να προσκομίσω μια δήλωση που να αναφέρει λεπτομερώς τις μειώσεις άνθρακα για τον πελάτη μου."
			},
			"internalProjectOrProduct": {
				"title": "Εσωτερικό έργο / προϊόν",
				"description": "Το υλικό χρησιμοποιήθηκε για ένα εσωτερικό έργο ή προϊόν. Πρέπει να δημιουργήσω μια δήλωση για να διεκδικήσω τις μειώσεις άνθρακα για τις δικές μας δραστηριότητες."
			}
		},
		"addProjectReferenceSection": {
			"title": "Προσθήκη αναφοράς έργου",
			"subTitle": "Πρέπει να αντιστοιχίσετε μειώσεις άνθρακα σε μια αναφορά έργου για την οποία θέλετε να δημιουργήσετε τη δήλωση.",
			"projectReferencePlaceholder": "Αναφορά έργου"
		},
		"selectProjectSection": {
			"title": "Επιλέξτε ένα έργο",
			"createNewProjectPlaceholder": "Δημιουργία νέου έργου"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Απαιτείται τύπος δήλωσης",
		"projectReferenceRequired": "Απαιτείται αναφορά στο έργο",
		"fetchProjectsError": "Αποτυχία ανάκτησης προηγούμενων έργων"
	}
}
